import { Button, Notification, toast } from 'demo/components/ui'
import { useState } from 'react'
import { HiOutlineUserCircle } from 'react-icons/hi'
import { backToMyAccount, impersonatorName, isImpersonating } from 'helper/impersonation'

/**
 * A permanent reminder that this is not your account, and the way out of it.
 *
 * Signing in as somebody else is easy to forget you have done - the portal looks
 * ordinary from inside a borrowed session, and every action taken there is recorded
 * against them. So this sits above everything, on every page, and cannot be dismissed:
 * the only way to remove it is to actually leave.
 */
export default function ImpersonationBanner() {
    const [leaving, setLeaving] = useState(false)

    if (!isImpersonating()) {
        return null
    }

    const onLeave = async () => {
        setLeaving(true)

        try {
            await backToMyAccount()
        } catch (e) {
            setLeaving(false)
            toast.push(
                <Notification type="danger">
                    Could not switch back. Sign out and in again.
                </Notification>
            )
        }
    }

    // Compact on a phone: one short line and a small button, rather than a four-line
    // paragraph beside a full-size button pushing the page down. Layout in SCSS
    // (.impersonation-banner) - the responsive utilities are not in the prebuilt sheet.
    return (
        <div className="impersonation-banner" role="status">
            <HiOutlineUserCircle
                className="impersonation-banner__icon"
                aria-hidden="true"
            />
            <span className="impersonation-banner__text">
                Signed in as{' '}
                <span className="font-semibold">
                    {localStorage.getItem('username')}
                </span>
                <span className="impersonation-banner__note">
                    {' '}
                    - anything you do is recorded against them.
                </span>
            </span>
            <Button
                size="xs"
                variant="solid"
                loading={leaving}
                onClick={onLeave}
                className="impersonation-banner__button"
                title={`Back to ${impersonatorName()}`}
            >
                <span className="impersonation-banner__button-label">
                    Back to {impersonatorName()}
                </span>
            </Button>
        </div>
    )
}
